export const universalWhatsAppLink =
  "https://wa.me/447405985739?text=Hi%20Ben%2C%20I%27m%20interested%20in%20Job%20Boost%20support.";

export const whatsappUrl = () => universalWhatsAppLink;

export const defaultWhatsAppMessage =
  "Hi Ben, I'm interested in Job Boost support.";